import { useQuery } from "@tanstack/react-query";
import api from "../../http";
import { useForBindingId } from "../../../forBinding";
import type { ParcelamentoAPI } from "@practium/features/parcelling";

export const useGetParcellingById = (id?: string) => {
	const forBinding = useForBindingId();

	return useQuery({
		queryKey: ["parcelling", id, forBinding],
		enabled: !!id,
		queryFn: async () => {
			const { data } = await api.get<ParcelamentoAPI>(`/advices/parcelling/get/${id}`, {
				params: { forBinding },
			});
			return data;
		},
	});
};
